import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import BrandHeader from '../../../components/common/BrandHeader';
import KeyTerm from '../../../components/common/KeyTerm';
import OutlineButton from '../../../components/common/OutlineButton';
import PrimaryButton from '../../../components/common/PrimaryButton';
import RescheduleEntry from '../../../components/common/RescheduleEntry';
import ResultHero from '../../../components/common/ResultHero';
import { Card, CardBody, PageShell } from '../../../components/common/Card';
import { CONTACT_PHONE } from '../../../constants/business';
import { ROUTE_PREFIX_BOOKING } from '../../../constants/routes';
import {
  PAYMENT_LINK_STATE,
  PAYMENT_LINK_STATE_CONTENT,
} from './paymentLinkStates';
import { ActionGroup, HeroImage } from './styles';

const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE.replace(/\s/g, '')}`;

const PaymentLinkStatusView = ({ linkState, workflow }) => {
  const { workflowId } = useParams();
  const history = useHistory();
  const {
    tone,
    heroIcon,
    title,
    subtitle,
    hasIllustration,
    hasRebookAction,
    keyTerms,
  } =
    PAYMENT_LINK_STATE_CONTENT[linkState] ||
    PAYMENT_LINK_STATE_CONTENT[PAYMENT_LINK_STATE.NOT_RECOGNISED];

  const handleRebook = () =>
    history.push(`${ROUTE_PREFIX_BOOKING}/${workflowId}`);

  return (
    <>
      <BrandHeader />
      <PageShell>
        <ResultHero
          tone={tone}
          icon={heroIcon}
          title={title}
          subtitle={subtitle}
        />

        {hasIllustration && (
          <HeroImage>
            <picture>
              <source
                srcSet={`${process.env.PUBLIC_URL}/assets/doctors-image.webp`}
                type="image/webp"
              />
              <img
                src={`${process.env.PUBLIC_URL}/assets/doctors-image.svg`}
                alt=""
              />
            </picture>
          </HeroImage>
        )}

        <Card>
          <CardBody>
            {keyTerms.map(({ key, icon, content }) => (
              <KeyTerm key={key} icon={icon}>
                {content}
              </KeyTerm>
            ))}
          </CardBody>
        </Card>

        {workflow && <RescheduleEntry workflow={workflow} />}

        {hasRebookAction && (
          <ActionGroup>
            <PrimaryButton onClick={handleRebook}>
              Book a new appointment
            </PrimaryButton>
            <OutlineButton href={CONTACT_PHONE_HREF}>
              Call {CONTACT_PHONE}
            </OutlineButton>
          </ActionGroup>
        )}
      </PageShell>
    </>
  );
};

export default PaymentLinkStatusView;
